export enum CompanyFieldType {
  SUBSCRIPTION_COMMISSION_RATE = 'SUBSCRIPTION_COMMISSION_RATE',
  JUSTIFICATIF_ORGINE_DES_FONDS_DOCUMENT = 'JUSTIFICATIF_ORGINE_DES_FONDS_DOCUMENT',
  PHONE_BILL_DOCUMENT = 'PHONE_BILL_DOCUMENT',
  GIRARDIN_INVESTMENT_AMOUNT = 'GIRARDIN_INVESTMENT_AMOUNT',
  GIRARDIN_TAX_REDUCTION_AMOUNT = 'GIRARDIN_TAX_REDUCTION_AMOUNT',
  GIRARDIN_COMMISSION_RATE = 'GIRARDIN_COMMISSION_RATE',
  JUSTIFICATIF_DOMICILE_DOCUMENT = 'JUSTIFICATIF_DOMICILE_DOCUMENT',
  IDENTITY_DOCUMENT = 'IDENTITY_DOCUMENT',
  CROWDFUNDING_INVESTMENT_AMOUNT = 'CROWDFUNDING_INVESTMENT_AMOUNT',
  CROWDFUNDING_NOMINATIF_PUR = 'CROWDFUNDING_NOMINATIF_PUR',
  CROWDFUNDING_INSIGHT_CHOICE = 'CROWDFUNDING_INSIGHT_CHOICE',
  CROWDFUNDING_PROJECT_DURATION = 'CROWDFUNDING_PROJECT_DURATION',
  CROWDFUNDING_INCLUDE_FEES_IN_SUBSCRIPTION_AMOUNT = 'CROWDFUNDING_INCLUDE_FEES_IN_SUBSCRIPTION_AMOUNT',
  CROWDFUNDING_FEES = 'CROWDFUNDING_FEES',
  RETIREMENT_AGE = 'RETIREMENT_AGE',
  SOCIAL_SECURITY_NUMBER = 'SOCIAL_SECURITY_NUMBER',
  PARENTS_NAMES = 'PARENTS_NAMES',
  SPOUSE_INFORMATION = 'SPOUSE_INFORMATION',
  PER_GARANTIE_BONNE_FIN = 'PER_GARANTIE_BONNE_FIN',
  PER_DEDUCTION_IMPOTS = 'PER_DEDUCTION_IMPOTS',
  PER_SORTIE = 'PER_SORTIE',
  OPTION_EPARGNE_HANDICAP = 'OPTION_EPARGNE_HANDICAP',
  FCPI_FEES = 'FCPI_FEES',
  FCPI_INCLUDE_FEES_IN_SUBSCRIPTION_AMOUNT = 'FCPI_INCLUDE_FEES_IN_SUBSCRIPTION_AMOUNT',
  FCPI_NOMINATIF_PUR = 'FCPI_NOMINATIF_PUR',
  PRIVATE_EQUITY_REDUCTION_AMOUNT = 'PRIVATE_EQUITY_REDUCTION_AMOUNT',
  DIVERSIFICATION_INVESTMENT_REDUCTION_AMOUNT = 'DIVERSIFICATION_INVESTMENT_REDUCTION_AMOUNT',
  PRIVATE_EQUIT_INVESTMENT_AMOUNT = 'PRIVATE_EQUIT_INVESTMENT_AMOUNT',
  MAXIMUM_LOST_PERCENT = 'MAXIMUM_LOST_PERCENT',
  NIF_CODE = 'NIF_CODE',
  FINANCIAL_EXPERIENCE = 'FINANCIAL_EXPERIENCE',
  FINANCIAL_INSTRUMENTS = 'FINANCIAL_INSTRUMENTS',
  STOCK_TRANSACTIONS = 'STOCK_TRANSACTIONS',
  OBLIGATIONS_TRANSACTIONS = 'OBLIGATIONS_TRANSACTIONS',
  MONETAIRES_TRANSACTIONS = 'MONETAIRES_TRANSACTIONS',
  STRUCTURED_PRODUCTS_TRANSACTIONS = 'STRUCTURED_PRODUCTS_TRANSACTIONS',
  INDIRECT_REAL_ESTATE_PRODUCTS_TRANSACTIONS = 'INDIRECT_REAL_ESTATE_PRODUCTS_TRANSACTIONS',
  OTHER_PRODUCTS_TRANSACTIONS = 'OTHER_PRODUCTS_TRANSACTIONS',
  AVERAGE_AMOUNT_TRANSACTIONS = 'AVERAGE_AMOUNT_TRANSACTIONS',
  AVERAGE_NUMBER_TRANSACTIONS_THREE_YEARS = 'AVERAGE_NUMBER_TRANSACTIONS_THREE_YEARS',
  RIB_DOCUMENT = 'RIB_DOCUMENT',
  KBIS_DOCUMENT = 'KBIS_DOCUMENT',
  ATTESTATION_BENEFICIAIRES_EFFECTIFS_DOCUMENT = 'ATTESTATION_BENEFICIAIRES_EFFECTIFS_DOCUMENT',
  STATUS_SOCIETE_DOCUMENT = 'STATUS_SOCIETE_DOCUMENT',
  RCS_REGISTRATION_EXTRACT_DOCUMENT = 'RCS_REGISTRATION_EXTRACT_DOCUMENT',
  BILAN_DOCUMENT = 'BILAN_DOCUMENT',
  ACCOUNT_RESULTS_DOCUMENT = 'ACCOUNT_RESULTS_DOCUMENT',
  FCPI_DELIVERY_MODE = 'FCPI_DELIVERY_MODE',
  PRIVATE_EQUITY_FEES = 'PRIVATE_EQUITY_FEES',
  CROWDFUNDING_ACTIONS_OBLIGATIONS = 'CROWDFUNDING_ACTIONS_OBLIGATIONS',
  POURCENTAGE_DE_REMISE = 'POURCENTAGE_DE_REMISE',
  CHILDREN_FORM = 'CHILDREN_FORM',
  LIVRET_DE_FAMILLE = 'LIVRET_DE_FAMILLE',
  CARTE_VITALE_DOCUMENT = 'CARTE_VITALE_DOCUMENT',
  JUSTIFICATIF_SITUATION_MATRIMONIALE_DOCUMENT = 'JUSTIFICATIF_SITUATION_MATRIMONIALE_DOCUMENT',
  CONTRAT_MARIAGE_DOCUMENT = 'CONTRAT_MARIAGE_DOCUMENT',
  OFFRE_DE_PRET_DOCUMENT = 'OFFRE_DE_PRET_DOCUMENT',
  FSI_DOCUMENT = 'FSI_DOCUMENT',
  SWISSLIFE_ACTIVITY_SECTOR_LCB_FT = 'SWISSLIFE_ACTIVITY_SECTOR_LCB_FT',
}
export enum SubscriberTypeEnum {
  PHYSICAL = 'PHYSICAL',
  COMPANY = 'COMPANY',
}
export enum CommandEnum {
  COMPLETE_PLEDGE_DATA = 'COMPLETE_PLEDGE_DATA',
  COMPLETE_OWNERS_DATA = 'COMPLETE_OWNERS_DATA',
  COMPLETE_PRODUCTS_DATA = 'COMPLETE_PRODUCTS_DATA',
  RECALCULATE_RISK_PROFIL = 'RECALCULATE_RISK_PROFIL',
  GENERATE_BANKING_GUARANTEES_EQUIVALENTS = 'GENERATE_BANKING_GUARANTEES_EQUIVALENTS',
  GENERATE_TARIFICATION_BORROWER_INSURANCE = 'GENERATE_TARIFICATION_BORROWER_INSURANCE',
  COMPUTE_DIGITAL_INSURE_PROFESSION_DETAILS = 'COMPUTE_DIGITAL_INSURE_PROFESSION_DETAILS',
  CHOOSE_PRODUCT_BORROWER_INSURANCE = 'CHOOSE_PRODUCT_BORROWER_INSURANCE',
  SAVE_OWNERS_DATA = 'SAVE_OWNERS_DATA',
  VERIFICATION_CONFORMITY = 'VERIFICATION_CONFORMITY',
  VERIFICATION_PLEDGE_PARAMETERS = 'VERIFICATION_PLEDGE_PARAMETERS',
  GENERATE_SUBSCRIPTION_FILE = 'GENERATE_SUBSCRIPTION_FILE',
  GENERATE_PACK_REGLEMENTAIRE = 'GENERATE_PACK_REGLEMENTAIRE',
  // Séquençage V2 — Commandes V2 packs (Adéquation/BS) + HTML éditable Froala + sauvegarde.
  GENERATE_PACK_ADEQUATION = 'GENERATE_PACK_ADEQUATION',
  GENERATE_PACK_BS = 'GENERATE_PACK_BS',
  GENERATE_PACK_REGLEMENTAIRE_HTML = 'GENERATE_PACK_REGLEMENTAIRE_HTML',
  GENERATE_PACK_ADEQUATION_HTML = 'GENERATE_PACK_ADEQUATION_HTML',
  SAVE_PACK_DOCUMENTS_HTML = 'SAVE_PACK_DOCUMENTS_HTML',
  // Séquençage V2 — Génère les PDFs preview (Puppeteer + addMetadata) à partir du
  // HTML édité, stocke en PrGed (S3) et lie via PrPackDocument.gedDocument. Affichés ensuite
  // par l'écran V2 `document-compliance` avant signature.
  PREVIEW_PACK_PDFS = 'PREVIEW_PACK_PDFS',
  // Séquençage V2 (Convention RTO retirable) — Supprime des PrPackDocument par id.
  // Payload : pledge.parameters.packDocumentIdsToExclude. Refuse les docs déjà signés.
  REMOVE_PACK_DOCUMENTS = 'REMOVE_PACK_DOCUMENTS',
  COMPUTE_COMMISSION = 'COMPUTE_COMMISSION',
  PROCESS_UNIVERSIGN_PREVALIDATION_COMMAND_CONSUMER = 'PROCESS_UNIVERSIGN_PREVALIDATION_COMMAND_CONSUMER',
  VERIFICATION_PLEDGE_RULES = 'VERIFICATION_PLEDGE_RULES',
  GENERATE_SCPI_PRODUCTS_FROM_PACK = 'GENERATE_SCPI_PRODUCTS_FROM_PACK',
  GENERATE_ADDITIONAL_QUESTIONS = 'GENERATE_ADDITIONAL_QUESTIONS',
  PRE_VERIFICATION_EXTERNAL_API = 'PRE_VERIFICATION_EXTERNAL_API',
  FILL_OPERATION_PLEDGE_PRODUCT = 'FILL_OPERATION_PLEDGE_PRODUCT',
  DOCUMENTS_SENT = 'DOCUMENTS_SENT',
  CONVERT_DOCUMENTS_TO_PDF = 'CONVERT_DOCUMENTS_TO_PDF',
  // PRE-4896 — préremplit les 4 champs "*Autocomplete" de supportRepartition (slide "Taux par support")
  COMPLETE_SUPPORT_RATES = 'COMPLETE_SUPPORT_RATES',
  COMPLETE_SIGNATURE_PLACE = 'COMPLETE_SIGNATURE_PLACE',
  RESYNC_FINANCIAL_DATA_FROM_AUDIT = 'RESYNC_FINANCIAL_DATA_FROM_AUDIT',
}
export enum StatusEnum {
  OPEN = 'OPEN',
  CANCELED = 'CANCELED',
  SIGNED = 'SIGNED',
  SUBMITTED = 'SUBMITTED',
  VALIDATED = 'VALIDATED',
  REJECTED = 'REJECTED',
  SENT = 'SENT',
  INCOMPLETE = 'INCOMPLETE',
  COMPLETE = 'COMPLETE',
  BROKEN = 'BROKEN',
}
export enum MissionLegalEntity {
  PROVISIONAL_BUDGET = 'PROVISIONAL_BUDGET',
  SOCIAL_MISSION = 'SOCIAL_MISSION',
  PACK_ESSENTIEL_SCI = 'PACK_ESSENTIEL_SCI',
  PACK_ESSENTIEL_SCI_IR = 'PACK_ESSENTIEL_SCI_IR',
  PACK_SARL = 'PACK_SARL',
}
export enum MissionParticulier {
  IRPP = 'IRPP',
  IFI = 'IFI',
  ACCOUNTING_TAKEOVER = 'ACCOUNTING_TAKEOVER',
  PACK_ESSENTIEL = 'PACK_ESSENTIEL',
  PACK_ESSENTIEL_REVENUS_FONCIERS = 'PACK_ESSENTIEL_REVENUS_FONCIERS',
  PACK_ESSENTIEL_REVENUS_FONCIERS_AVEC_DISPOSITIF = 'PACK_ESSENTIEL_REVENUS_FONCIERS_AVEC_DISPOSITIF',
}

export enum OptionServiceDelivery {
  ADDITIONAL_PROPERTY = 'ADDITIONAL_PROPERTY',
  TNS_AFFILIATION = 'TNS_AFFILIATION',
}
//optionLegalEntity
